import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { PlanoAcaoSituacao } from '../../models/plano-acao-situacao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAtividadeSituacaoService } from '../../services/indicadores-atividade-situacao.service';
import { IndicadoresPgAtividadeSituacaoService } from '../../services/indicadores-pg-atividade-situacao.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PlanoAcaoSituacaoService } from '../../services/plano-acao-situacao.service';

@Component({
  selector: 'app-detalhe-projeto-situacao-edit',
  templateUrl: './detalhe-projeto-situacao-edit.component.html',
  styleUrls: ['./detalhe-projeto-situacao-edit.component.scss']
})
export class DetalheProjetoSituacaoEditComponent extends BaseFormComponent<PlanoAcaoSituacao> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  idPlanoAcao: number;
  actionLabel: string = 'Nova';
  list: any;
  isIndicador: boolean;
  isPgIndicador: boolean;
  pgType: string = '';

  constructor(
    private planoAcaoSituacaoService: PlanoAcaoSituacaoService,
    private atividadeSituacaoService: IndicadoresAtividadeSituacaoService,
    private pgAtividadeSituacaoService: IndicadoresPgAtividadeSituacaoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.list = this.activatedRoute.snapshot.data['list'];
      if (!this.entity?.id && this.activatedRoute.snapshot.params['id']) {
        this.idPlanoAcao = this.activatedRoute.snapshot.params['id'];
      }
      this.isIndicador = this.activatedRoute.snapshot.data['isIndicador'];
      this.isPgIndicador = this.activatedRoute.snapshot.data['isPgIndicador'];
      this.pgType = this.activatedRoute.snapshot.data['type'];
      this.initForm();
      this.loaded();
    });
  }

  initForm() {
    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.list = this.entity;
    }

    this.form = new FormGroup({
      description: new FormControl('', [Validators.required]),
      dt_start: new FormControl(!this.list?.start ? null : this.list?.dt_start_action, [Validators.required]),
      dt_start_action: new FormControl({ value: this.list?.dt_start_action, disabled: true }),
      dt_deadline: new FormControl({ value: this.list?.dt_deadline, disabled: true }),
      deadline: new FormControl(null, [Validators.required]),
      prt_issue_action_stat_id: new FormControl(null, !this.isIndicador && !this.isPgIndicador ? [Validators.required] : []),
      ind_action_stat: new FormControl(null, this.isIndicador || this.isPgIndicador ? [Validators.required] : []),
      action_id: new FormControl(this.idPlanoAcao, [Validators.required]),
      extras: new FormArray([]),
    });

    if (this.entity) {
      this.form.patchValue(this.entity);
    }

    this.list?.extras?.forEach((item) => {
      item.decimal_places = String(item?.decimal_places);
      this.getFormArray().push(this.createFormGroup(item))
    })
  }

  typeStatusForm(): string {
    return this.isIndicador || this.isPgIndicador ? 'ind_action_stat' : 'prt_issue_action_stat_id'
  }

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      extra_id: new FormControl(values?.extra_id),
      title: new FormControl(values?.title),
      unit_id: new FormControl(values?.unit_id),
      decimal_places: new FormControl(values?.decimal_places),
      done: new FormControl(null, [Validators.required]),
      value_done_last_one: new FormControl(values?.value_done_last_one),
      goal: new FormControl(values?.goal),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('extras') as FormArray;
  }

  addMedida() {
    this.getFormArray().push(this.createFormGroup());
  }

  removeMedida(index: number) {
    this.getFormArray().removeAt(index);
  }

  voltar() {
    let rota = this.isIndicador ? 'atividade' : 'plano-acao'
    if (this.isPgIndicador) {
      this.navigation.back(['projetos', this.pgType ?? 'agregador', 'atividade', this.entity?.action_id || this.idPlanoAcao]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, rota, this.entity?.action_id || this.idPlanoAcao]);
    }
  }

  getDataCreate(): PlanoAcaoSituacao {
    let data: PlanoAcaoSituacao;
    data = Object.assign({}, data, this.form.value);

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!formatoDataRegex.test(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    }
    if (!formatoDataRegex.test(data.deadline)) {
      data.deadline = formatDate(data.deadline, 'DD/MM/YYYY');
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_start', 'deadline')) {
      this.loading();
      
      if (this.isPgIndicador) {
        if (this.entity?.id) {
          this.addSub(
            this.pgAtividadeSituacaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!')
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.pgAtividadeSituacaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', this.pgType ?? 'agregador', 'atividade', 'situacao', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      }
      else if (this.isIndicador) {
        if (this.entity?.id) {
          this.addSub(
            this.atividadeSituacaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!')
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.atividadeSituacaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'atividade', 'situacao', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      } else {
        if (this.entity?.id) {
          this.addSub(
            this.planoAcaoSituacaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!')
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.planoAcaoSituacaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'plano-acao', 'situacao', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      }
    }
    else {
      this.markAsDirty();
      this.getFormArray().controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
      })
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formatarMedidaFisica(index: number) {
    let goalValue = this.getFormArray().controls[index].get('done')?.value;
    let decimalPlacesValue = this.getFormArray().controls[index].get('decimal_places')?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, decimalPlacesValue);
    this.getFormArray().controls[index].get('done').setValue(value);
  }
}
